import { Extension } from '@tiptap/core';

export const NodeIdGlobalExtension = Extension.create({
  name: 'nodeIdGlobal',

  addGlobalAttributes() {
    return [
      {
        types: [
          'paragraph',
          'blockquote',
          'bulletList',
          'codeBlock',
          'doc',
          'hardBreak',
          'heading',
          'horizontalRule',
          'listItem',
          'orderedList',
          'taskList',
          'taskItem',
          'RL_CITATION',
          'RL_GROUPED_SECTION_TEMP',
          'RL_CUSTOM_SECTION',
        ],
        attributes: {
          nodeId: {
            default: null,
          },
        },
      },
    ];
  },
});
